import React, { useContext, useEffect } from 'react'
import TeacherAttendanceContext from '../contextfolder/TeacherAttendanceContext/TeacherAttendanceContext';

export default function RouteFormEdit({ closeEditPop }) {

    const context = useContext(TeacherAttendanceContext)

    const { toggleEditModal, attendanceFormError, setAttendanceFormError, editIsSubmit, setEditIsSubmit, attendanceValue, attendanceFormValue, setAttendanceFormValue, active, setActive, editroutedata, closeChecked, setCloseChecked } = context;



    const handleChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        setAttendanceFormValue({ ...attendanceFormValue, [name]: value });
    };

    const handleActive = () => {
        setActive(!active)
    }

    const handleOnChange = () => {
        setCloseChecked(!closeChecked);
    };



    const formSubmit = (e) => {
        e.preventDefault();
        setAttendanceFormError(validate(attendanceFormValue));
        setEditIsSubmit(true);
    }

    useEffect(() => {
        if (Object.keys(attendanceFormError).length === 0 && editIsSubmit) {
            editroutedata(attendanceFormValue)
            if (closeChecked === true) {
                toggleEditModal();
            }
            setEditIsSubmit(false);
        }

    }, [attendanceFormError]);

    const validate = (values) => {

        const errors = {};
        if (!values.name) {
            errors.name = "Required";
        }
        if (!values.ssid) {
            errors.ssid = "Required";
        }
        

        return errors;
    };



    return (
        <>

            <div className="container-fluid basicform" >

                <form >

                    <div className="form-group">
                        <label htmlFor="name" className="form-label" style={{ fontSize: "12px" }}>
                            Name<sup style={{ color: "red" }}>*</sup>
                        </label>
                        <input
                            id="name"
                            style={{ fontSize: "13px" }}
                            type="text"
                            className="form-control form-control-sm "
                            name="name"
                            value={attendanceFormValue.name}
                            onChange={handleChange}
                        />
                        <p className="errormsg " style={{ marginBottom: "0" }}>{attendanceFormError.name}</p>

                    </div>


                    

                        <div className="form-group">
                            <label className="form-label" htmlFor="ssid">SSID <sup style={{ color: "red" }}>*</sup></label>
                            <input
                                id="ssid"
                                style={{ fontSize: "13px" }}
                                type="text"
                                className="form-control form-control-sm "
                                name="ssid"
                                value={attendanceFormValue.ssid}
                                onChange={handleChange}
                            />
                            <p className="errormsg " style={{ marginBottom: "0" }}>{attendanceFormError.ssid}</p>
                        </div>

                       

                

                    {/* <div className="form-row">

                        <div style={{ marginLeft: "9px", marginTop: "15px" }}>
                            <input
                                type="checkbox"
                                // className="form-check-input"
                                id="exampleCheck3"
                                name="notWorking"
                                onChange={handleActive}
                                checked={active}
                            />
                            <label class="form-check-label" for="exampleCheck3" style={{ fontSize: "12px", paddingLeft: "3px" }}>
                                Active
                            </label>
                        </div>
                    </div> */}


                </form>


            </div>
            <div className="FormFooter">
                <div className='checkedClose'>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck2"
                        name="closeChecked"
                        onChange={handleOnChange}
                        checked={closeChecked}
                    />
                    <label class="form-check-label" for="exampleCheck2">
                        Exit after submit
                    </label>
                </div>
                <div>
                    <button className='btn btn-sm btn-cmpy ml-2' style={{ background: "green" }} onClick={formSubmit} >Submit</button>
                    <button className='btn btn-sm btn-cmpy ml-2' onClick={closeEditPop}>Cancel</button>
                </div>
            </div>

        </>

    )
}
